// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { BINARY_BLOCK_MODE } from './../../../types/next/blocks/binaryBlock'
import { blockBaseSettingsSchema, iBlockSchema } from './baseBlock.zod'

export const binaryBlockModeSchema = z.nativeEnum(BINARY_BLOCK_MODE)

export const binaryBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.BINARY_INPUT),
  settings: blockBaseSettingsSchema.and(
    z.object({
      mode: binaryBlockModeSchema,
      default: z.boolean()
    })
  )
})

export const binaryBlockValueSchema = z.boolean()
